// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-text{max-width:250px}.tooltip-text__title{margin-bottom:3px}.tooltip-text__description{margin:0;font-size:11px}\n", ""]);
// Exports
module.exports = exports;
